module.exports = __webpack_public_path__ + "static/media/cellfinate_banner_diagnostico.e7c83197.jpg";